import type {CopilotChatThread, CustomCopilotId} from '@github-ui/copilot-chat/utils/copilot-chat-types'

export function copilotSpaceIdFromThread(thread?: CopilotChatThread | null): CustomCopilotId | null {
  if (!thread || !thread.customCopilotID || !thread.customCopilotOwner) return null

  return {
    id: thread.customCopilotID,
    owner: thread.customCopilotOwner,
  }
}
